// extracted by mini-css-extract-plugin
export default {"noteMessage":"noteMessage--va4v19tJ","noteMessageInner":"noteMessageInner--l7kjICOB"};